import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { VideoRoom } from "protogen/video_pb";
import { AccountStub } from "protogen/common_pb";
import VideoCallActivityPanel from "components/details-page/VideoCallsActivityPanel";
import VideoCommentsListPanel from "./VideoCommentsListPanel";

interface VideoCallTranscriptAndCommentsProps {
  videoRoom: VideoRoom | null;
  participants: AccountStub[];
  token?: string;
}

const VideoCallTranscriptAndComments: React.FC<
  VideoCallTranscriptAndCommentsProps
> = ({ videoRoom, participants, token }) => {
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        sx={{
          borderBottom: "1px solid #975d331a",
          px: 2,
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          sx={{
            minHeight: "48px",
            "& .MuiTab-root": {
              minHeight: "48px",
              textTransform: "none",
              fontSize: "14px",
            },
          }}
        >
          <Tab label="Transcript" />
          <Tab label="Comments" />
        </Tabs>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0 }}>
        {activeTab === 0 ? (
          <VideoCallActivityPanel
            videoRoom={videoRoom}
            participants={participants}
          />
        ) : (
          <VideoCommentsListPanel
            videoRoomUuid={videoRoom?.uuid || ""}
            token={token}
          />
        )}
      </Box>
    </Box>
  );
};

export default VideoCallTranscriptAndComments;
